import { Injectable } from "@angular/core";
import { IAccount, IEthnicGroup, IHealthcareservice } from "@comunicare/comunicare-interfaces";
import { Observable } from "rxjs";
import { ApiService } from "./api.service";
import { BaseApiService } from "./baseApi.service";

@Injectable({
  providedIn: "root",
})
export class UserApiService extends BaseApiService {
  constructor(private api: ApiService) {
    super(
      "User", // Theme !
      ["account"], // Post route paths
      ["users", "me", "service"], // Get route paths
      [], // Put route paths
      [] // Delete route paths
    );
  }

  /**
   * Search the dashboard users the current user has access to (autocomplete)
   * @param search the text typed by the user. If empty, the server returns an empty list
   */
  public search(search: string): Observable<IAccount[]> {
    return this.api.get(this.readRoutes[0], { search }) as Observable<IAccount[]>;
  }

  public me(): Observable<IAccount> {
    return this.api.get(this.readRoutes[1]) as Observable<IAccount>;
  }

  public updateAccount(account: IAccount): Observable<Record<string, never>> {
    return this.api.post(this.createRoutes[0], account) as Observable<Record<string, never>>;
  }

  public getMyService(): Observable<IHealthcareservice> {
    return this.api.get(this.readRoutes[2]) as Observable<IHealthcareservice>;
  }

  public getAllEthnicGroups(): Observable<IEthnicGroup[]> {
    return this.api.get("dashboard/ethnicGroups") as Observable<IEthnicGroup[]>;
  }
}
